import script from "./CategoryFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryFormView.vue?vue&type=script&setup=true&lang=js"

import "./CategoryFormView.vue?vue&type=style&index=0&id=8071a9a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8071a9a4"]])

export default __exports__